import {FileMetadataBase, IFileMetadataBase} from './FileMetadataBase';

export class CompanyFileMetadata extends FileMetadataBase implements ICompanyFileMetadata {
  companyId?: string;
  filePath?: string | undefined;

  constructor(data?: ICompanyFileMetadata) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.companyId = _data['companyId'];
      this.filePath = _data['filePath'];
    }
  }

  static fromJS(data: any): CompanyFileMetadata {
    data = typeof data === 'object' ? data : {};
    const result = new CompanyFileMetadata();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['companyId'] = this.companyId;
    data['filePath'] = this.filePath;
    super.toJSON(data);
    return data;
  }
}

export interface ICompanyFileMetadata extends IFileMetadataBase {
  companyId?: string;
  filePath?: string | undefined;
}